export const PEN_TOOL_ID = "freehand";

export const penToolConfig = {
  id: PEN_TOOL_ID,
  usesPreview: false,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint }) => {
    ctx.beginPath();
    ctx.moveTo(lastPointRef.current.x, lastPointRef.current.y);
    ctx.lineTo(nextPoint.x, nextPoint.y);
    ctx.stroke();
    lastPointRef.current = nextPoint;
  },
  onEnd: () => {},
};

const PenToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === PEN_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(PEN_TOOL_ID)}
      title="Pen"
      aria-label="Pen"
    >
      ✎
    </button>
  );
};

export default PenToolButton;
